import { Button, Flex, Text } from '@radix-ui/themes'
import { PlayWalletStatus } from 'shared/store/play-wallet'
import { shortenAddress } from 'shared/utils/shorten-address'
import styles from '../wallets.module.scss'

interface Props {
  status: PlayWalletStatus | null
  connectedAddress: string | null
  isLinking: boolean
  onLinkConnected: () => void
  onSelectConnected: (address: string) => void
}

/** Explains why game actions are blocked for the connected wallet. */
export const PlayWalletNotice: React.FC<Props> = ({
  status,
  connectedAddress,
  isLinking,
  onLinkConnected,
  onSelectConnected
}) => {
  if (!connectedAddress || !status || status === PlayWalletStatus.ready) {
    return null
  }

  const shortAddress = shortenAddress(connectedAddress)

  if (status === PlayWalletStatus.notLinked) {
    return (
      <Flex
        direction='column'
        gap='3'
        className={styles.notice}
      >
        <Text
          size='2'
          weight='bold'
        >
          The connected wallet {shortAddress} is not linked to your account
        </Text>
        <Text size='2'>
          Games are blocked for this wallet. Anything it plays is recorded for a
          separate anonymous account, and the wallet can then never be linked to
          yours. Link it first, or switch to a linked wallet in your wallet app.
        </Text>
        <Button
          color='yellow'
          disabled={isLinking}
          onClick={onLinkConnected}
        >
          Link {shortAddress}
        </Button>
      </Flex>
    )
  }

  return (
    <Flex
      direction='column'
      gap='3'
      className={styles.notice}
    >
      <Text
        size='2'
        weight='bold'
      >
        The connected wallet {shortAddress} is not the one selected for play
      </Text>
      <Text size='2'>
        Switch to the selected wallet in your wallet app, or play with the
        connected one.
      </Text>
      <Button
        color='yellow'
        onClick={() => onSelectConnected(connectedAddress)}
      >
        Play with {shortAddress}
      </Button>
    </Flex>
  )
}
